/* Livish branded dropdown: LVDD.enhance(selectElement). The native select stays in the page (hidden) and keeps the value, so forms and scripts work as before. After changing its options in code, call select._dd.refresh(). */
(function(){
if(window.LVDD)return;
var cur=null;
function enhance(sel){
if(sel._dd)return sel._dd;
var wrap=document.createElement('div'),btn=document.createElement('button'),lab=document.createElement('span'),chev=document.createElement('span'),list=document.createElement('ul'),api={};
wrap.className='lvdd';
btn.type='button';btn.className='lvdd-btn';btn.setAttribute('aria-haspopup','listbox');btn.setAttribute('aria-expanded','false');
var al=sel.getAttribute('aria-label');if(al)btn.setAttribute('aria-label',al);
lab.className='lvdd-lab';chev.className='lvdd-chev';chev.setAttribute('aria-hidden','true');
btn.appendChild(lab);btn.appendChild(chev);
list.className='lvdd-list';list.setAttribute('role','listbox');list.hidden=true;if(al)list.setAttribute('aria-label',al);
sel.parentNode.insertBefore(wrap,sel);
wrap.appendChild(btn);wrap.appendChild(list);wrap.appendChild(sel);
sel.classList.add('lvdd-native');sel.tabIndex=-1;sel.setAttribute('aria-hidden','true');
function items(){return [].slice.call(list.children)}
function refresh(){
list.innerHTML='';
var o=sel.options,i=sel.selectedIndex<0?0:sel.selectedIndex;
[].forEach.call(o,function(op,n){
var li=document.createElement('li');
li.setAttribute('role','option');li.tabIndex=-1;li.textContent=op.textContent;
if(n===i)li.setAttribute('aria-selected','true');
li.addEventListener('click',function(){pick(n)});
list.appendChild(li)});
lab.textContent=o[i]?o[i].textContent:'';
wrap.classList.toggle('is-set',i>0);
wrap.hidden=!!sel.hidden||o.length<2}
function pick(n){sel.selectedIndex=n;close(true);sel.dispatchEvent(new Event('change',{bubbles:true}));refresh()}
function open(){
if(cur&&cur!==api)cur.close();
refresh();
list.hidden=false;list.classList.remove('lvdd-flip');
var r=list.getBoundingClientRect(),vw=document.documentElement.clientWidth;
if(r.right>vw-8||r.left<8)list.classList.add('lvdd-flip');
btn.setAttribute('aria-expanded','true');wrap.classList.add('is-open');cur=api;
var s=list.querySelector('[aria-selected=true]')||list.firstChild;
if(s){s.focus({preventScroll:true});list.scrollTop=Math.max(0,s.offsetTop-list.clientHeight/2)}}
function close(back){
list.hidden=true;btn.setAttribute('aria-expanded','false');wrap.classList.remove('is-open');if(cur===api)cur=null;if(back)btn.focus({preventScroll:true})}
btn.addEventListener('click',function(){if(list.hidden)open();else close(true)});
btn.addEventListener('keydown',function(e){if(e.key==='ArrowDown'||e.key==='ArrowUp'){e.preventDefault();if(list.hidden)open()}});
list.addEventListener('keydown',function(e){
var a=items(),i=a.indexOf(document.activeElement);
if(e.key==='ArrowDown'){e.preventDefault();a[Math.min(a.length-1,i+1)].focus()}
else if(e.key==='ArrowUp'){e.preventDefault();a[Math.max(0,i-1)].focus()}
else if(e.key==='Home'){e.preventDefault();a[0].focus()}
else if(e.key==='End'){e.preventDefault();a[a.length-1].focus()}
else if(e.key==='Enter'||e.key===' '){e.preventDefault();if(i>-1)pick(i)}
else if(e.key==='Escape'){e.preventDefault();close(true)}
else if(e.key==='Tab'){close(false)}});
api={wrap:wrap,refresh:refresh,close:close};
sel._dd=api;refresh();return api}
document.addEventListener('click',function(e){if(cur&&!cur.wrap.contains(e.target))cur.close()});
window.LVDD={enhance:enhance};
})();
